import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  examInfoColumnDefs,
  examInfoColumnDefsExamineeRole,
  examInfoDetails,
  status,
} from '../../constants/QuestionBankConstants';
import {
  apiPaths,
  deleteData,
  get,
  getData,
  postData,
} from '../../platform-components/api-integration-util';
import Grid from '../../platform-components/grid/Grid';
import { PreLoader } from '../../platform-components/PreLoader';
import { Toaster } from '../../platform-components/Toaster';
import {
  checkPermission,
  getSelectedExamInfo,
  setExamInfo,
  setSelectedExamInfo,
} from '../../platform-components/utils/configuration';
import {
  getRoleNameList,
  getUserDetails,
} from '../../platform-components/utils/shared-data.service';
import { formatDataToTableColumnValues } from '../../../utils/dataFormatter';
import { Box, Button, button, Checkbox, FormControl, FormControlLabel, Modal, Switch, Typography } from '@mui/material';
// import Switch from "react-switch";
import { useConfirm } from "material-ui-confirm";
import CloseIcon from '@mui/icons-material/Close';

const style = {
  width:"500px",
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};
const icon = {
  position: "absolute",
  top:" 6px",
  right: "11px",
  fontSize: "16px",
  cursor:"pointer"
}


export default function ExamsInfo(props) {
  let [gridOptions, setGridOptions] = useState({});
  let [showGrid, setShowGrid] = useState(false);
  let [displayPayment, setDisplayPayment] = useState(false);
  let [updateGridDetails, setUpdateGridDetails] = useState(false);
  let [selectedRows, setSelectedRows] = useState([]);
  let { id } = useParams();
  let [examsTakenByUser, setExamsTakenByUser] = useState([]);
  let [enableCheckboxSwitch, setEnableCheckboxSwitch] = useState(true)
  let [comments, setComments] = useState('')
  let [updateStatusEvent, setUpdateStatusEvent] = useState('')
  let [displayApproveCommentDialog, setDisplayApproveCommentDialog] = useState(false)
  const [includeExplanation, setIncludeExplanation] = useState(false);
  const [includeAnswer, setIncludeAnswer] = useState(false);
  const [includeQuestion, setIncludeQuestion] = useState(false);
  const [showModal, setShow] = useState(false);
  const [singleComment, setSingleComment] = useState()
  const [open, setOpen] = useState(false);

  const handleDownload = () => {
    setShow(true);
  };

  const handleOpen = (data) => {
    setSingleComment(data.value)
    setOpen(true)
  }

  const handleClose = () => {
    setShow(false);
    setOpen(false)
  };

  const linkFunction = (params) => {
    return (
      <div>
        <div
          className='text-link'
          onClick={() => {
            console.log('clicked');
            setSelectedExamInfo(params.data);
            props.history.push({
              pathname: `/app/exams/examDetailView/${params.data.examId}`,
            });
          }}
        >
          {params?.value}
        </div>
      </div>
    );
  };
  const ActionButton = (params) => {
    let btnText = '';
    if (params.data.examAvailableType === 'Free') {
      if (Object.keys(examsTakenByUser).includes(params.data.examId)) {
        btnText = 'Take Exam';
      } else {
        btnText = 'View Exam';
      }
    } else {
      if (Object.keys(examsTakenByUser).includes(params.data.examId)) {
        btnText = 'Take Exam';
      } else {
        btnText = 'Enroll';
      }
    }
    return (
      <input
        class='btn-common'
        type='button'
        value={btnText}
        onClick={() => {
          setSelectedExamInfo(params.data);
          if (btnText == 'Enroll') {
            setDisplayPayment(true);
          } else {
            props.history.push('/app/exams/takeorviewexam');
          }
        }}
      />
    );
  };

  const onPaymentOk = () => {
    setDisplayPayment(false);
    if (!Object.keys.includes(getSelectedExamInfo().examId)) {
      let userExamMap = {
        userId: getUserDetails()?.userId,
        examId: getSelectedExamInfo().examId,
        tenantId: getUserDetails()?.tenantId,
        questionsAttempted: 0,
        questiosCorrect: 0,
        timeTaken: 0,
        examStatus: 'ENROLLED',
        createdBy: getUserDetails()?.email,
        createdDate: new Date(),
      };

      postData(apiPaths.updateuserexamstatus, userExamMap)
        .then((res) => Toaster(toast.TYPE.SUCCESS, 'Enrolled Successfully'))
        .catch((err) => Toaster(toast.TYPE.ERROR, 'Enrollment Failed'));
    }
  };

  const plotGrid = (rowData) => {
    console.log('rowData: ', rowData);
    const columnDefArray = examInfoColumnDefs(handleOpen);
    columnDefArray.forEach((ele) => {
      if (ele?.field === 'examName') {
        ele.cellRendererFramework = linkFunction;
      }
    });
    if (getRoleNameList().includes('Examinee')) {
      examInfoColumnDefsExamineeRole.forEach((ele) => {
        if (ele.field === 'action') {
          ele.cellRendererFramework = ActionButton;
        }
      });
      // rowData = rowData.filter(
      //   (ele) =>
      //     ele.examActiveState && ele.examActiveState.toLowerCase() === 'yes'
      // );
    }
    let newGridOptions = gridOptions
    newGridOptions.pagination = true;
    newGridOptions.domLayout = '';
    newGridOptions.rowSelection = 'multiple';
    newGridOptions.suppressRowClickSelection = true;
    newGridOptions.columnDefs = columnDefArray;
    newGridOptions.columnDefs =
      getRoleNameList().includes('Examinee')
        ? examInfoColumnDefsExamineeRole
        : columnDefArray;
        newGridOptions.rowData = rowData
        newGridOptions.onSelectionChanged = (params) => {
      setSelectedRows(params.api.getSelectedRows());
    };

    newGridOptions.isRowSelectable = (params) => {
      return (
        ((enableCheckboxSwitch && (params.data.status === status.APPROVED || params.data.status === "PUSHED TO APP" || params.data.status === "REJECTED")) || (!enableCheckboxSwitch && (params.data.status !== status.APPROVED && params.data.status !== "PUSHED TO APP" && params.data.status !== "REJECTED"))) && getRoleNameList().includes('Admin')
      );
    };
    setGridOptions(gridOptions);
    setShowGrid(true);
  };
  useEffect(() => {
    getExamDetails();
  }, [enableCheckboxSwitch]);

  const getExamDetails = () => {
    getData(apiPaths.examsList, {
      headers: { tenantId: getUserDetails()?.tenantId, userEmail: getUserDetails()?.email },
    }).then(async (res) => {
      setShowGrid(false);
      setExamInfo(res?.result);

      if (getRoleNameList().includes('Examinee')) {
        let val = await get(apiPaths.examstakenbyuser, {
          userId: getUserDetails().userId,
        });
        if (val?.result instanceof Array) {
          setExamsTakenByUser(
            val?.result.reduce((acc, currentVal) => {
              return (acc[currentVal.examId] = currentVal);
            }, {})
          );
        }
      }
      plotGrid(res?.result);
    });
  };

  const updateExamActiveStatus = (examActiveState) => {
    postData(apiPaths.updateExamActiveStatus, {
      data: selectedRows?.map((i) => i.examId),
      params: { examActiveState: examActiveState },
    }).then((res) => {
      if (res && res.result) {
        getExamDetails();
        Toaster(
          toast.TYPE.SUCCESS,
          examActiveState === examInfoDetails.ACTIVATE_VALUE
            ? 'Exam Activated'
            : 'Exam Deactivated'
        );
      }
    });
  };

  const buttonActionsClick = (selectedRows, action) => {
    console.log(selectedRows);
    if (action === examInfoDetails.ACTIVATE) {
      if (
        selectedRows.every(
          (i) => i.examActiveState === examInfoDetails.DEACTIVATE_VALUE
        )
      ) {
        updateExamActiveStatus(examInfoDetails.ACTIVATE_VALUE);
      } else {
        Toaster(
          toast.TYPE.ERROR,
          'Please select only not activated exams to Activate'
        );
      }
    } else if (action === examInfoDetails.DEACTIVATE) {
      if (
        selectedRows.every(
          (i) => i.examActiveState === examInfoDetails.ACTIVATE_VALUE
        )
      ) {
        updateExamActiveStatus(examInfoDetails.DEACTIVATE_VALUE);
      } else {
        Toaster(
          toast.TYPE.ERROR,
          'Please select only activated exams to Deactivate'
        );
      }
    }
  };

  const confirm = useConfirm();

  const deleteExam = () => {
    if (selectedRows.length > 0) {
      confirm({
        description: 'Confirm to delete'})
        .then(() => {
              const deleteIds = selectedRows.map((el) => el.examId);
              deleteData(apiPaths.deleteExam, {
                data: deleteIds,
                headers: {
                  tenantId: getUserDetails().tenantId,
                  userEmail: getUserDetails().email,
                },
              })
                .then((res) => {
                  getExamDetails();
                })
                .catch((err) => console.log(err));
            }).catch(() => {
            /* ... */
          });
    };
  }

  const handleChangeStatus= () => {
    postData(apiPaths.updateExamStatus, {
      data: {
        "comment": comments,
        "examId": selectedRows[0].examId,
        "status": updateStatusEvent
      },
      headers: {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email
      }
    })
      .then((res) => {
        setComments('')
        setUpdateStatusEvent('')
        setDisplayApproveCommentDialog(false)
        getExamDetails()
      })
      .catch((err) => console.log(err));
  }

  const handleDownloadPaper = () => {
    postData(`${apiPaths.downloadExamPaper}/${selectedRows[0].examId}?includeExplanation=${includeExplanation}&includeQuestion=${includeQuestion}&includeAnswer=${includeAnswer}`, {
      headers: {
        tenantId: getUserDetails().tenantId,
        userEmail: getUserDetails().email
      }
    })
      .then(async (res) => {
        var bb = new Blob([res ], { type: 'text/html' });
        var a = document.createElement('a');
        a.download = 'index.html';
        a.href = window.URL.createObjectURL(bb);
        a.click();
      })
      .catch((err) => console.log(err));
  }

  const linkRef = React.createRef();

  return (
    <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
      <div className='main-heading'>Exams</div>
      {!showGrid && <PreLoader />}
      {checkPermission('enableCheckboxSwitch') && (
                <div style={{display: 'flex', alignItems: 'center', margin: '10px 0'}}>

                <Switch defaultChecked size="small" onChange={() => setEnableCheckboxSwitch(!enableCheckboxSwitch)
              } checked={enableCheckboxSwitch} /> <i style={{marginLeft: '5px'}}>{enableCheckboxSwitch ? 'Show checkbox for approved/Push to apps only' :'Show checkbox for not approved only' } </i> </div>
              )}
      <a ref={linkRef}/>
      {showGrid && (
        <div className='background-common-div'>
          <div class='btn-div'>
            <div style={{float: 'right'}}>
              {checkPermission('createExam') && (
                <button
                  class='btn-common'
                  variant='outlined'
                  onClick={() => props.history.push('/app/exams/createExam')}
                > Create Exam</button>
              )}
              {checkPermission('copyExam') && (
                <button
                  class='btn-common'
                  variant='outlined'
                  disabled={selectedRows.length === 0 || selectedRows.length > 1}
                  onClick={() => props.history.push(`/app/exams/copyExam/${selectedRows[0].examId}/${selectedRows[0].examName}?branchId=${selectedRows[0].branchId}&batchId=${selectedRows[0].batchId}`)}
                >Copy Exam</button>
              )}
              {checkPermission('sendForApproval') && (
                <button
                  class='btn-common'
                  variant='outlined'
                  disabled={enableCheckboxSwitch || selectedRows.length === 0 || (selectedRows.length > 0 && selectedRows[0].status === 'SENT FOR APPROVAL') || selectedRows.length > 1}
                  onClick={() => {
                    setUpdateStatusEvent('SENT FOR APPROVAL')
                    setDisplayApproveCommentDialog(true)
                  }}
                >Send For Approval</button>
              )}
              {checkPermission('approved') && (
                <button
                  class='btn-common'
                  variant='outlined'
                  disabled={enableCheckboxSwitch || selectedRows.length === 0 || (selectedRows.length > 0 && selectedRows[0].status !== 'SENT FOR APPROVAL') || selectedRows.length > 1}
                  onClick={() => { 
                    setUpdateStatusEvent('APPROVED')
                    setDisplayApproveCommentDialog(true)
                  }
                  }
                >Approved</button>
              )}
              {checkPermission('reject') && (
                <button
                  class='btn-common'
                  variant='outlined'
                  disabled={enableCheckboxSwitch || selectedRows.length === 0 || (selectedRows.length > 0 && (selectedRows[0].status !== 'SENT FOR APPROVAL' || selectedRows[0].status !== 'REJECTED' || selectedRows[0].status !== 'APPROVED')) || selectedRows.length > 1}
                  onClick={() => { 
                    setUpdateStatusEvent('REJECTED')
                    setDisplayApproveCommentDialog(true)
                  }
                  }
                >Rejected</button>
              )}
              {checkPermission('deleteExam') && (
                <button
                  class='btn-common'
                  variant='outlined'
                  disabled={enableCheckboxSwitch || selectedRows.length === 0}
                  onClick={() => deleteExam()}
                >Delete</button>
              )}
              {checkPermission('pushToApp') && (
                <button
                  class='btn-common'
                  variant='outlined'
                  value='Push To App'
                  disabled={!enableCheckboxSwitch || selectedRows.length === 0 || selectedRows.length > 1 || (selectedRows.length > 0 && (selectedRows[0].status === "PUSHED TO APP" || selectedRows[0].status === "REJECTED"))}
                  onClick={() => props.history.push(`/app/exams/pushToApp/${selectedRows[0].examId}/${selectedRows[0].batchId}`)}
                >Push To App</button>
              )}
              {checkPermission('download') && (
                <button
                  variant='outlined'
                  class='btn-common'
                  value='Download'
                  disabled={selectedRows.length === 0 || selectedRows.length > 1}
                  onClick={() => handleDownload()}
                >Download</button>
              )}

              {/* {checkPermission('download') && (
                <button
                  class='btn-common'
                  variant='outlined'
                  value='Download with Explanation'
                  disabled={selectedRows.length === 0 || selectedRows.length > 1}
                  onClick={() => handleDownloadPaper(true)}
                >Download with Explanation</button>
              )} */}

            </div>
            
          </div>
          
          {showGrid && (
            <div className='common-div-alt'>
              <Grid gridOptions={gridOptions} parent="examinfo"/>
            </div>
          )}
        </div>
      )}
      <div
        id='myModal'
        class='modal fade show'
        role='dialog'
        style={{ display: displayPayment ? 'block' : '' }}
      >
        <div class='modal-dialog modal-dialog-custom'>
          <div class='modal-content'>
            <div class='modal-header modal-header-custom'>
              <button
                type='button'
                class='close'
                data-dismiss='modal'
                onClick={() => {
                  setDisplayPayment(false);
                }}
              >
                <div class='close-btn'>
                  <i class='fa fa-close' aria-hidden='true'></i>
                </div>
              </button>
            </div>
            <div class='modal-body modal-body-custom'>
              {displayPayment ? (
                <div class='comments-div'>
                  <div class='comments-text-div'>Payment GateWay</div>
                  <textarea
                    class='textarea-custom'
                    // onChange={($event) => (comments = $event.target.value)}
                    // value={comments}
                  ></textarea>
                  <button
                    class='btn-common float-right'
                    onClick={() => onPaymentOk(0)}
                    data-dismiss='modal'
                  >
                    OK
                  </button>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>


      { displayApproveCommentDialog && <div
          id='myModal'
          class='modal show'
          style={{display: 'block'}}
          role='dialog'
        >
          <div class='modal-dialog modal-dialog-custom'>
            <div class='modal-content'>
              <div class='modal-header modal-header-custom'>
                <button
                  type='button'
                  class='close'
                  data-dismiss='modal'
                  onClick={() => {
                    setComments('');
                    setDisplayApproveCommentDialog(false)
                  }}
                >
                  <div class='close-btn'>
                    <i class='fa fa-close' aria-hidden='true'></i>
                  </div>
                </button>
              </div>
              <div class='modal-body modal-body-custom'>
                  <div class='comments-div'>
                    <div class='comments-text-div'>Add comments</div>
                    <textarea
                      class='textarea-custom'
                      onChange={($event) => setComments($event.target.value)}
                      value={comments}
                    ></textarea>
                    <button
                      class='btn-common float-right'
                      onClick={() => {
                        handleChangeStatus()
                   
                      }}
                      data-dismiss='modal'
                    >
                      OK
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>}

        <Modal open={showModal} onClose={handleClose} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box sx={{ p: 2, width: 400, backgroundColor: '#fff', borderRadius: '4px', boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.15)' }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Download Exam Paper
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={includeExplanation}
              onChange={(e) => setIncludeExplanation(e.target.checked)}
            />
          }
          label="Include Explanation"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={includeAnswer}
              onChange={(e) => setIncludeAnswer(e.target.checked)}
            />
          }
          label="Include Answer"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={includeQuestion}
              onChange={(e) => setIncludeQuestion(e.target.checked)}
            />
          }
          label="Include Question"
        />
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" onClick={handleDownloadPaper}>
            Download
          </Button>
          <Button variant="outlined" sx={{ ml: 2 }} onClick={handleClose}>
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>

    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      >
      
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Comment Details
        </Typography>
        <CloseIcon sx={icon}  onClick={handleClose} />
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
        <Typography><span style={{fontWeight:"bold"}}>Comment:</span> {singleComment ? singleComment : "No Comments"}</Typography>
        </Typography>
      </Box>
      </Modal>
    </div> 
  );
}
